<template lang="pug">

</template>

<script>
export default {
  name: 'Home',
  components: {},
  mounted () {
    this.$router.push('/product')
  }
}
</script>

<style lang="scss" scoped>

</style>